import { keyboardModifiersMatchHotkeyBase } from './hotkeyFunctions.ts';
import type { Hotkey } from './hotkeys';

/** Same window as digit buffer in `useLayoutNavigationHotkeys` for multi-key chords. */
export const HOTKEY_CHORD_TIMEOUT_MS = 600;

export type PendingHotkeyChord<TName extends string> = {
  name: TName;
  hotkey: Hotkey;
};

/** `true` when `ev` is the secondary stroke of `pending` with the same modifier chord as the definition. */
export function chordSecondaryMatches<TName extends string>(
  ev: KeyboardEvent,
  pending: PendingHotkeyChord<TName>
): boolean {
  const sec = pending.hotkey.secondary;
  if (!sec) return false;
  if (ev.code !== sec.code) return false;
  return keyboardModifiersMatchHotkeyBase(ev, pending.hotkey);
}
